import { useEffect, useRef, useState } from "react";

/**
 * Lightweight IntersectionObserver hook to replace framer-motion whileInView.
 * Returns a ref to attach and a boolean `inView` (fires once).
 */
export function useInView<T extends HTMLElement = HTMLDivElement>(
  threshold = 0.15
): [React.RefObject<T>, boolean] {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref as React.RefObject<T>, inView];
}
